import { NavProps, NavItemDto } from '../types';
import { NAV_ITEMS } from './constants';

export const mapTiles = (
  items: NavItemDto[],
): NavProps[] => {
  const mappedTiles = items.map((items) => ({
    title: items.title,
    path: items.external_link,
    lookupCode: items.lookup_code,
  }));

  mappedTiles.forEach((mappedTile) => {
    const navIndex = NAV_ITEMS.findIndex(
      (items) => items.lookupCode === mappedTile.lookupCode
    );
    if (navIndex !== -1) {
      if (mappedTile.path !== null && mappedTile.path !== '') {
        NAV_ITEMS[navIndex].path = mappedTile.path;
      }
      if (mappedTile.title !== null && mappedTile.title !== '') {
        NAV_ITEMS[navIndex].label = mappedTile.title;
      }
    }
  });

  return NAV_ITEMS;
};
